// extracted by mini-css-extract-plugin
export default {"ScrollToTop":"ScrollToTop_ScrollToTop__B2r9c","Visible":"ScrollToTop_Visible__yulyp"};